import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { selectors as UsersSelectors } from 'data/users'
import { selectors as PaymentSelectors } from 'data/payment'
import providesInvoicesList from '../dataSync/providesInvoicesList'
import InvoicesList from './List'
import ErrorMessage from '../components/ErrorMessage'
import { Text } from 'components/base'

class SettingsBillingInvoices extends Component {
  render() {
    if (!this.props.hasAccess) {
      return <div>You don't have access to this section</div>
    }

    if (this.props.invoicesFetchState.error) {
      return (
        <ErrorMessage
          action="getting your invoices"
          retry={this.props.forceQuery}
          message={this.props.invoicesFetchState.error.message}
        />
      )
    }

    if (
      this.props.invoicesFetchState.pristine ||
      this.props.invoicesFetchState.loading
    ) {
      return <div>Loading your invoices...</div>
    }

    return (
      <div className="shade-05 padding-vertical-large">
        <Text.Subtitle className="margin-bottom-large">
          Your billing history
        </Text.Subtitle>
        {this.props.invoices.length ? (
          <InvoicesList invoices={this.props.invoices} className="width-full" />
        ) : (
          <div>You have no invoice yet.</div>
        )}
      </div>
    )
  }
}

export default compose(
  providesInvoicesList,
  connect(state => ({
    hasAccess: UsersSelectors.hasAccessToPaidBillingViews(state),
    invoices: PaymentSelectors.getAllInvoices(state),
  }))
)(SettingsBillingInvoices)
